/*
 * @Author: lzz
 * @Date: 2024-06-09 12:43:29
 * @LastEditTime: 2024-08-07 09:42:39
 */
import request from '@/utils/request'

// 获取路由
export const getArticleList = (query) => {
    return request.get('/app-api/sems/article/page', { params: query })
}
export const getArticleById = (query) => {
    return request.get('/app-api/sems/article/get', { params: query })
}

// 文章分类
export const getArticleTypeList = (query) => {
    return request.get('/app-api/sems/article-category/list-all-simple', { params: query })
}

export const userAddLike = (data) => {
    return request.post('/app-api/sems/member-like/like', data)
}
export const userCancelLike = (data) => {
    return request.put('/app-api/sems/member-like/unlike', data)
}
// 课程
export const getTerm = (query) => {
    return request.get('/app-api/sems/course/page', { params: query })
}

// 课程
export const getByCourseId = (query) => {
    return request.get('/app-api/sems/member-course/getByCourseId', { params: query })
}


export const getLessonById = (query) => {
    return request.get('/app-api/sems/course/get', { params: query })
}
export const getCurrentTerm = (query) => {
    return request.get('/app-api/sems/term/getCurrentTerm', { params: query })
}


// 自评管理

export const getEvaluateList = (query) => {
    return request.get('/app-api/sems/evaluate/page', { params: query })
}
export const getMyEvaluateList = (query) => {
    return request.get('/app-api/sems/member-evaluate/get', { params: query })
}

export const addEvaluate = (data) => {
    return request.post('/app-api/sems/member-evaluate/create', data)
}

export const getExamList = (query) => {
    return request.get('/app-api/sems/member-paper/start', { params: query })
}
export const updateExam = (data) => {
    return request.put('/app-api/sems/member-paper-question/answer', data)
}

export const updateStudy = (data) => {
    return request.post('/app-api/sems/member-course/study', data)
}

export const upload = (data) => {
    return request.post('/app-api/infra/file/upload', data)
}

export const addUserPromise = (data) => {
    return request.post('/app-api/sems/member-agreement/create', data)
}
export const genUserPromiseImg = (query) => {
    return request.get('/app-api/sems/member-agreement/create-crt-img',  { params: query })
}

export const addUserCert = (data) => {
    return request.post('/app-api/sems/member-credential/create', data)
}

// 获取承诺书
export const getPromiseList = (query) => {
    return request.get('/app-api/sems/member-agreement/page', { params: query })
}

// 获取证书
export const getCertList = (query) => {
    return request.get('/app-api/sems/member-credential/page', { params: query })
}
// 获取评论列表
export const getCommentList = (query) => {
    return request.get('/app-api/sems/member-comment/page', { params: query })
}
// 获取用户评论列表
export const getUserCommentList = (query) => {
    return request.get('/app-api/sems/member-comment/mypage', { params: query })
}
// 创建用户评论
export const addComment = (data) => {
    return request.post('/app-api/sems/member-comment/create', data)
}

// 用户答题
export const addAnswer = (data) => {
    return request.put('/app-api/sems/member-paper-question/update', data)
}
//获取用户是否点赞过文章
export const getContentIsLike = (data) => {
    return request.post('/app-api/sems/member-like/getByRef', data)
}

//用户点赞记录
export const getLikeList = (query) => {
    return request.get('/app-api/sems/member-like/page', { params: query })
}

// 获取部门列表
export const getDepartList = (query) => {
    return request.get('/app-api/system/dept/list-all-simple', { params: query })
}


// 获取高管寄语
export const getManagerMessage = (query) => {
    return request.get('/app-api/sems/manager-message/page', { params: query })
}

// 获取主题分页
export const getThemeList = (query) => {
    return request.get('/app-api/sems/theme-image/page', { params: query })
}
export const getThemeById = (query) => {
    return request.get('/app-api/sems/theme-image/get' , { params: query })
}

// 获取答题记录
export const getExamListByTermId = (query) => {
    return request.get('/app-api/sems/member-paper/getByTermId', { params: query })
}

// 获取个人信息
export const getUserInfo = (query) => {
    return request.get('/app-api/member/user/get', { params: query })
}

export const getCredential = (query) => {
    return request.get('/app-api/sems/credential/get', { params: query })
}

// 获取个人课程
export const getUserCourse = (query) => {
    return request.get('/app-api/sems/member-course/page', { params: query })
}

// 获取个人课程统计
export const getUserCourseTotal = (query) => {
    return request.get('/app-api/sems/member-course/total', { params: query })
}

// 创建用户评论
export const userLogin = (data) => {
    return request.post('/app-api/member/auth/login', data)
}

// 字典数据
export const getDictData = (query) => {
    return request.get('/app-api/system/dict-data/type', { params: query })
}

// 配置数据
export const getConfigByKey = (key) => {
    return request.get('/app-api/infra/config/get-value-by-key?key=' +key )
}

// 社交授权的跳转
export const socialAuthRedirect = (query) => {
    console.log("query", query)
    return request.get('/app-api/member/auth/social-auth-redirect', { params: query })
}


export function socialLogin(data) {
    return request.post('/app-api/member/auth/social-login', data)
}

// export function downByPath(path) {
//     return request.get('/app-api/infra/file/download-by-path/'+path)
// }

export function downByPath(path) {
    return request({
        url: '/app-api/infra/file/download-by-path/' + path,
        method: 'get',
        responseType: "blob", // 加上这个是重点
    })
}

export function getMessage(query) {
    return request.get('/app-api/system/notify-message/my-page', { params: query })

}

export const updataMsgRead = (id) => {
    return request.put('/app-api/system/notify-message/update-read?ids=' + id)
}


export function getAgreePic(query) {
    return request.get('/app-api/sems/agreement/get', { params: query })
}

export function logout(query) {
    return request.get('/app-api/member/auth/social-logout', { params: query })
}

export const deleteComment = (query) => {
    return request.delete('/app-api/sems/member-comment/deleteById', { params: query })
}

// 社交授权的跳转
export const feelbackUri = (query) => {
    return request.get('/app-api/sems/member-feelback/show-window', { params: query })
}